import styled from 'styled-components';
import { color, screen, spacing } from 'theme';

export const Root = styled.div`
  background: ${color('sun_100')};
  padding: ${spacing('xl3')} 0;

  .stack {
    margin: auto;
    max-width: 1250px;

    @media (max-width: ${screen('lg')}) {
        gap: 1rem;
    }
  }
  
  .text {
    margin: 5rem 0;

    @media (max-width: ${screen('lg')}) {
      margin: 1rem 0;
    }

    h2 strong {
      color: ${color('indigo_700')};
    }

    p {
      font-size: 1.25rem;
      margin-bottom: 2rem;
    }
  }

  .video {
    iframe {
        aspect-ratio 0.75;
        border-radius: 1rem;
        width: 528px;

        @media (max-width: ${screen('lg')}) {
          width: 100%;
        }
    }
  }
`;

export const Logo = styled.img``;
